export const PASSWORD_MIN = 6
